import React, { Suspense, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

// UI components
import { Row, Col, Container, Card, Spinner } from "react-bootstrap";

// State
import { loginWithToken } from "../../state/actions/user";

// Utilities
import queryString from "query-string";
import { log } from "../../utils/logger";

/**
 * Simple page to display visual feedback that SSO Log In has succeeded before the pop-up/page closes
 */
const Page = () => {
  return (
    <Container data-testid="sign-in">
      <Row className="justify-content-md-center align-items-center" style={{ height: "90vh" }}>
        <Col md={8} xl={6}>
          <Card className="text-center">
            <Card.Body>
              <Spinner animation="border" role="status" variant="primary" />
            </Card.Body>

            <Card.Body className="text-muted">
              <Card.Text>Please wait while we prepare your details...</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const ErrorCard = ({ message }: { message: string }) => (
  <Container data-testid="sign-in">
    <Row className="justify-content-md-center align-items-center" style={{ height: "90vh" }}>
      <Col md={8} xl={6}>
        <Card className="text-center">
          <Card.Body>Sorry</Card.Body>

          <Card.Body className="text-muted">
            <Card.Text>{message}</Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
);

function CentralizedServicesToken(props: any) {
  const { user, loginWithToken } = props;
  const { api_token, account_number, user_number } = queryString.parse(props.location.search);

  useEffect(() => {
    if (api_token) {
      let firstApiToken = Array.isArray(api_token) ? api_token[0] : api_token;
      loginWithToken(firstApiToken, { api_token, account_number, user_number });
    }
  }, [api_token, account_number, user_number, loginWithToken]);

  if (!api_token || !account_number) {
    log("%user missing api_token or account number", "color:red");
    return (
      <Redirect
        to={{
          pathname: "/401",
          search: "?message=Missing+required+token+or+account+number",
        }}
      />
    );
  }

  if (user.isAuthenticated) {
    log("%cUser Has been authenticated - redirecting to dashboard", "color:green");
    return <Redirect to="/home" />;
  }

  return (
    <Suspense fallback={null}>
      {user.errors.token ? <ErrorCard message={user.errors.token} /> : <Page />}
    </Suspense>
  );
}

const mapStateToProps = (state: any) => ({
  user: state.user,
});

CentralizedServicesToken.propTypes = {
  user: PropTypes.object.isRequired,
  loginWithToken: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { loginWithToken })(CentralizedServicesToken);
